var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"admin_action_logs"}},[_c('Navbar',{attrs:{"current":"Logs de Admin"}}),_c('Sidebar'),_c('Container',{attrs:{"col":"col-12"}},[_c('Header',{attrs:{"title":"Logs de Admin","subtitle":"Auditoria de ações tomadas por administradores","iconClass":'fa-solid fa-clipboard-list text-primary'}}),_c('AdminActionLogsList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }